/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';
import { PublicidadTarjetas, ResponseHorasVeterinaria, Veterinaria } from './veterinaria.types';

@Injectable({
    providedIn: 'root',
})
export class VeterinariaService {
    private apiUrl: string = environment.BASE_URL ;
    private _veterinaria: BehaviorSubject<Veterinaria > = new BehaviorSubject<Veterinaria>(null);
    private _veterinarias: BehaviorSubject<Veterinaria[] > = new BehaviorSubject<Veterinaria[]>(null);
    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
    ) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    //////////////////////////////////////////////////////////////////////////////////////////////////


    /**
     * Getter for Veterinaria
     */
    get veterinaria$(): Observable<Veterinaria> {
        return this._veterinaria.asObservable();
    }

    set veterinaria(vet: Veterinaria){
      this._veterinaria.next(vet);
  }

    /**
     * Getter for Veterinarias
     */
    get veterinarias$(): Observable<Veterinaria[]> {
        return this._veterinarias.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Get Veterinaria by id
     */

  
    getPublicidad(): Observable<PublicidadTarjetas[]> {
        return new Observable(observer => {
          fetch('/assets/images/publicidad/publicidad.json')
            .then(response => {
              if (!response.ok) {
                throw new Error('Error al cargar el archivo JSON');
              }
              return response.json();
            })
            .then(data => {
              observer.next(data);
              observer.complete();
            })
            .catch(error => {
              observer.error(error);
            });
        });
      }
      


    getHorasOcupadasByFecha(fecha:string, idVet: number): Observable<ResponseHorasVeterinaria[]>{
      return this._httpClient.get<ResponseHorasVeterinaria[]>(this.apiUrl +`suscriptor/traer-horas-dia-ocupadas-idveterinaria-xdia/${fecha}/${idVet}`);
    }

    getVeterinarias(): Observable<Veterinaria[]>
    {
        return this._httpClient.get<Veterinaria[]>(this.apiUrl + 'suscriptor/veterinaria/').pipe(
            switchMap((Veterinarias: Veterinaria[]) =>
            {
                this._veterinarias.next(Veterinarias);
                return of(Veterinarias);
            }),
            catchError((error: any) => {
              return of([]);
            }));
    }

    getVeterinariaById(id: string): Observable<Veterinaria> {
        return this._httpClient.get<Veterinaria>(this.apiUrl + '/' + id).pipe(
            take(1),
            switchMap((Veterinaria: Veterinaria) => {
                if (!Veterinaria) {
                    return throwError(
                        'Could not found Veterinaria with id of ' + id + '!'
                    );
                }
                this._veterinaria.next(Veterinaria);
                this.updateVeterinariaInList(Veterinaria);
                return of(Veterinaria);
            })
        );
    }

    updateVeterinaria(Veterinaria: Veterinaria): Observable<Veterinaria> {
        return this._httpClient.put<Veterinaria>(this.apiUrl + '/', Veterinaria).pipe(
            take(1),
            switchMap((Veterinaria: Veterinaria) => {
                this._veterinaria.next(Veterinaria);
                this.updateVeterinariaInList(Veterinaria);
                return of(Veterinaria);
            })
        );
    }
    deleteVeterinaria(id: string): Observable<boolean> {
        return this._httpClient.delete<any>(this.apiUrl + id).pipe(
            take(1),
            switchMap((data: any) => {
                this.updateVeterinariaInList(this.getVeterinariaByIdInList(+id));
                return of(data);
            })
        );
    }
    /**
     * Create Veterinaria
     */
    createVeterinaria(Veterinaria: Veterinaria): Observable<Veterinaria> {
        return this._httpClient.post<Veterinaria>(this.apiUrl, Veterinaria).pipe(
            take(1),
            switchMap((Veterinaria: Veterinaria) => {
                this._veterinarias.next([Veterinaria, ...this._veterinarias.value]);
                return of(Veterinaria);
            })
        );
    }

    /*
     *
     *Funciones auxiliares
     */

    // Función para actualizar un objeto Veterinaria en la lista
    updateVeterinariaInList(updatedVeterinaria: Veterinaria): void {
        const currentVeterinarias = this._veterinarias.getValue();

        if (currentVeterinarias) {
          const indice = currentVeterinarias.findIndex(group => group.id === updatedVeterinaria.id);
          if (indice !== -1) {
            currentVeterinarias[indice] = updatedVeterinaria;
              this._veterinarias.next([...currentVeterinarias]); // Emite una nueva lista actualizada
          } else {
              console.log(`No se encontró ningún Veterinaria con el ID ${updatedVeterinaria.id}.`);
          }
      } else {
          console.log('La lista de grupos está vacía.');
      }
    }

    getVeterinariaByIdInList(id: number): Veterinaria | null{
        const currentVeterinarias = this._veterinarias.value;

        if (currentVeterinarias) {
            this._veterinarias.value.map((Veterinaria: Veterinaria) => {
                if (Veterinaria.id === id) {
                    return Veterinaria;
                }
            });

            return null;
        }
    }
}
